<template lang="html">

<div class="purchase container column full-height" v-if="step === 0">

  <h3 class="purchase__title"><span>Confirm</span> your purchase</h3>


  <div class="purchase__info container">

    <div class="purchase__info__cupom column align-center">
      <span>Value</span>
      <p>{{ product.name }}</p>
      <!-- <p>R$30</p> -->
      <span>OFF</span>
    </div>

  <div  class="purchase__info__text container column">
    <div class="margin-bottom-10">
      <h4>Desrição</h4>
      <p>{{ product.description }}</p>
    </div>
      <div class="margin-bottom-10">
        <h4>Válido para</h4>
        <p>O uso deste cupom é válido somente em produtos extras da marca Minds, isentando qualquer desconto no curso, material didático e afins.</p>
        <p><span>Transação:</span> {{ coins }}<span> (your coins)</span> - {{ product.price }}<span> (price)</span> = {{ coins - product.price }}</p>
      </div>
    </div>
  </div>


    <div class="purchase__confirm__footer container align-center">
        <button type="button" name="button" class="btn btn-full btn-gradient-red btn-rounded margin-right-10" @click="close()">Cancel</button>
        <button type="button" name="button" class="btn btn-full btn-gradient-green btn-rounded" @click="confirmPayment()">Confirm</button>
    </div>
</div>

<div class="purchase container column full-height" v-else-if="step === 1">

  <h3 class="purchase__title"><span>Your</span> voucher</h3>


  <div class="purchase__info container">

    <div class="purchase__info__cupom column align-center">
      <span>Value</span>
      <p>{{ product.name }}</p>
      <!-- <p>R$30</p> -->
      <span>OFF</span>
    </div>

  <div  class="purchase__info__text container column">
    <div>
      <h4>Desrição</h4>
      <p class="margin-bottom-20">{{ product.description }}</p>
      <div class="container">
        <button type="button" name="button" class="btn btn-full btn-gradient-blue btn-rounded margin-right-10">Enviar para email</button>
        <button type="button" name="button" class="btn btn-full btn-gradient-blue btn-rounded">Imprimir</button>
      </div>
    </div>
    <div class="purchase__info__code-box align-center">
      <div class="purchase__info__code-box__textcode align-center">code</div>
      <div class="purchase__info__code-box__voucher align-center">{{ voucher }}</div>
    </div>
    </div>
  </div>
    <div class="purchase__confirm__footer container align-center">
        <button type="button" name="button" class="btn btn-full btn-gradient-red btn-rounded" @click="close()">Close</button>
    </div>
</div>

    <!-- <div class="purchase__response full-width container column justify-content-center align-item-center" v-else-if="step === 1">
      <div class="purchase__response__content">
        <div class="purchase__response__content__message">
          Voucher bellow
        </div>
        <div class="purchase__response__content__voucher">
          {{ voucher }}
        </div>
      </div>
      <div class="purchase__response__button">
        <button type="button" name="button" class="btn btn-full btn-gradient-red btn-rounded" @click="close()">Close</button>
      </div>
    </div> -->


  <!-- <div class="purchase container full-height">
    <div class="purchase__confirm full-width container column align-center" v-if="step === 0">
      <div class="purchase__confirm__header container align-center margin-bottom-10">
        <h3>Confirm purchase</h3>
      </div>
      <div class="purchase__confirm__body flex-grow-1 container column align-center margin-bottom-10">
        <div class="purchase__confirm__body__name margin-bottom-10">
          <h4>{{ product.name }}</h4>
        </div>
        <div class="purchase__confirm__body__description margin-bottom-20">
          <p>{{ product.description }}</p>
        </div>
        <div class="purchase__confirm__body__coins column align-center">
          <div class="purchase__confirm__body__coins__price">
            <span>{{ product.price }}</span>
          </div>
          <div class="purchase__confirm__body__coins__wallet purchase__confirm__body__coins__wallet--before">
            <span>{{ coins }}</span>
          </div>
          <div class="purchase__confirm__body__coins__wallet purchase__confirm__body__coins__wallet--after">
            <span>{{ coins }} - {{ product.price }} = {{ coins - product.price }}</span>
          </div>
        </div>
      </div>
      <div class="purchase__confirm__footer container align-center">
        <button type="button" name="button" class="btn btn-full btn-gradient-red btn-rounded margin-right-10" @click="close()">Cancel</button>
        <button type="button" name="button" class="btn btn-full btn-gradient-green btn-rounded" @click="confirmPayment()">Confirm</button>
      </div>
    </div>
    <div class="purchase__response full-width container column justify-content-center align-item-center" v-else-if="step === 1">
      <div class="purchase__response__content">
        <div class="purchase__response__content__message">
          Voucher bellow
        </div>
        <div class="purchase__response__content__voucher">
          {{ voucher }}
        </div>
      </div>
      <div class="purchase__response__button">
        <button type="button" name="button" class="btn btn-full btn-gradient-red btn-rounded" @click="close()">Close</button>
      </div>
    </div>
  </div> -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "PurchaseModal",
  props: {
    product: {
      type: Object,
      required: true
    },
    close: {
      type: Function,
      default: () => console.log('Close Event!')
    }
  },
  data () {
    return {
      step: 0,
      voucher: null
    }
  },
  computed: {
    coins () {
      return parseInt(this.$store.getters['student/GET'].coins)
    }
  },
  methods: {
    async confirmPayment () {
      try {
        this.$store.commit('setShowLoader', true)
        this.voucher = await this.$store.dispatch('store/buy', this.product)
        this.step++
      } catch (e) {
        console.warn(e);
        alert('Purchase failed!')
      } finally {
        this.$store.commit('setShowLoader', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>


.purchase{
  background: none;
  padding: 50px;
  justify-content: space-between;

  &__title{
    color: #1474BC;
    font-size: 30px;
    text-transform: uppercase;
    span{
      color: #165280;
      font-weight: 400;
      }
  }
  &__info{
    &__cupom{
      background: #5EFFC8;
      height: 180px;
      width: 300px;
      justify-content: space-evenly;
      border-radius: 15px;
      color: #055C77;
      p{
        font-size: 50px;
        // color: #055C77;
        }
        span{
          background: #b8ffe7;
          padding: 5px 30px;
          width: 75%;
          text-align: center;
          border-radius: 300px;
        }
    }
    &__text{
      flex-direction: column;
      justify-content: space-evenly;
      margin-left: 20px;
      width: 100%;
      h4{
        color: #165280;
        font-weight: 400;
        font-size: 15px;
      }
      p{
        font-weight: 200;
        color: #777;
        span{
          color: rgb(221, 151, 0);
          font-weight: 300;
          line-height: 40px;
        }
      }

    }
    &__code-box{
      background: #d0d0d0;
      border-radius: 300px;
      border: 1px solid black;
      // padding: 10px;
      &__textcode{
        background: #a4a4a4;
        color: white;
        margin: 5px;
        padding: 10px 30px;
        border-radius: 300px;
      }
      &__voucher{
        // background: #a4a4a4;
        color: #4e4e4e;
        margin: 5px;
        border-radius: 300px;
        width: 100%;
        font-size: 20px;
        letter-spacing: 2px;
        text-align: center;
      }
    }
  }

}

// .purchase {
//   &__confirm {
//     color: #000;
//     &__header{
//       color:red;
//       text-transform: uppercase;
//     }
//     &__body {
//       &__name {}
//       &__description { font-size: 18px; }
//       &__coins {
//         font-size: 36px;
//         &__price {}
//         &__wallet {}
//         &__wallet--before {}
//         &__wallet--after {}
//       }
//     }
//     &__footer {
//       button.btn {
//         width: 150px;
//         font-size: 18px !important;
//       }
//     }
//   }
// }

</style>



// WEBPACK FOOTER //
// src/components/modal/modalPurchase.vue